import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dateFormatter',
    standalone: false
})
export class DateFormatterPipe implements PipeTransform {

    /**
     * Asynchronous pipe, transforms a utc date into a formatted date.
     */
    transform(value: any, showTime?: boolean): string {
        if (value) {
            let date = value instanceof Date ? value : new Date(value);
            if (!showTime) {
                return date.toLocaleDateString();
            } else {
                return date.toLocaleString();
            }
        }
        return value;
    }}
